import React from 'react';
import { Container, Group, LogoContainer, UserInfo, UserName } from './Header.styles';

interface IHeaderProps {
  showSearchInput?: boolean;
  logo?: React.ReactNode;
  searchComponent?: React.ReactNode;
  userAvatar?: React.ReactNode;
  userName?: string;
}

export const Header: React.FC<IHeaderProps> = ({ showSearchInput, logo, searchComponent, userAvatar, userName }) => {
  return (
    <Container>
      <LogoContainer>{logo}</LogoContainer>

      <Group>
        {showSearchInput && (searchComponent || <input type="text" placeholder="Search..." />)}

        <UserInfo>
          {userAvatar}
          <UserName>{userName ?? 'Guest'}</UserName>
        </UserInfo>
      </Group>
    </Container>
  );
};
